import React from 'react';
import '../applications-css/Application.css'
import '../applications-css/WebBrowser.css'

class WebBrowser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: "http://whirlygig.github.io",
      archiveMode: false,
      history: [],
      forwardURL: ""
    }
    this.urlLoader = this.urlLoader.bind(this);
    this.archiveLoader = this.archiveLoader.bind(this);
  }

  componentDidMount() {
      var input = this.refs.inputURL;
      input.addEventListener("keyup", this.enterHandler);
      this.refs.inputURL.value = this.state.url;
    }

  componentWillUnmount() {
    var input = this.refs.inputURL;
    input.removeEventListener("keyup", this.enterHandler);
  }

  enterHandler = (e) => {
    if(e.keyCode === 13) {
      console.log("enter hit");
      this.urlLoader();
    }
  }

  backHandler() {
    if(this.state.history.length > 0) {
      let newHistory = this.state.history;
      let newForwardURL = this.state.url;
      let parsedURL = newHistory.pop();
      this.refs.inputURL.value = parsedURL;
      this.setState({
        url: parsedURL,
        history: newHistory,
        forwardURL: newForwardURL
      })
    }
  }

  forwardHandler() {
    if(this.state.forwardURL !== "") {
      let parsedURL = this.state.forwardURL;
      let newHistory = this.state.history;
      newHistory.push(this.state.url);
      let newForwardURL = "";
      this.refs.inputURL.value = parsedURL;
      this.setState({
        url: parsedURL,
        history: newHistory,
        forwardURL: newForwardURL
      })
    }
  }

  refreshHandler() {
    let parsedURL = this.state.url;
    this.setState(
      {
        url: "about:blank",
      },
      function() {
        this.setState({
          url: parsedURL,
        })
      }
    );
  }

  urlLoader() {
    let newURL = this.refs.inputURL.value.trim();
    try {
      let parsedURL = new URL(newURL);
      let newHistory = this.state.history;
      newHistory.push(this.state.url);
      this.setState({
        url: parsedURL.toString(),
        history: newHistory
      })
    }
    catch (_) {
      newURL = "http://" + newURL;
      try {
        let parsedURL = new URL(newURL);
        let newHistory = this.state.history;
        newHistory.push(this.state.url);
        this.setState({
          url: parsedURL.toString(),
          history: newHistory
        })
      }
      catch (_) {
        // TODO return an error
      }
    }
    console.log(this.state.history)
  }

  archiveLoader() {
    let request = new XMLHttpRequest();
    let newURL = this.refs.inputURL.value.trim();
    let url = 'https://api.archivelab.org/wayback/' + newURL;
    let archiveURL = null;
    request.open('GET', url);
    request.onload = function() {
        if(request.status >= 200 && request.status < 400) {
            let data = JSON.parse(this.response);
            console.log(data.archived_snapshots.closest.url);
            archiveURL = data.archived_snapshots.closest.url;
        }
    }
    this.setState({
      url: archiveURL,
    })
    request.send();
  }

  aboutHandler() {
    console.log("about")
    return(
      <span>
        <img src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p>You can browse the internet. (Mostly.)</p>
      </span>
    );
  }

  helpHandler() {
    return(
      <span>
        <img src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p> Type in some URLs and see if they allow content embedding. </p>
      </span>
    );
  }

  render() {
      return(
        <div id="browserWrapper" className="outsideWrapper">
          <div id="browserHeader">
            <button onClick = {() => this.backHandler()}> ◄ </button>
            <button onClick = {() => this.forwardHandler()}> ► </button>
            <input type="text" id="urlInputField" ref="inputURL" spellCheck="false" rows="1" autoFocus>
            </input>
            <button onClick = {() => this.refreshHandler()}> ⟳ </button>
          </div>
          <iframe title="web browser" src={this.state.url}></iframe>
        </div>
      )
  }
}

export default WebBrowser;
